import { AfterViewInit, Directive, Host, Input, OnDestroy, Optional, Self } from '@angular/core';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { GridComponent } from '@progress/kendo-angular-grid';
import { Datasource } from './datasource';

@Directive({
    selector: '[datasource]'
})
export class DatasourceDirective implements AfterViewInit, OnDestroy {

    @Input('datasource') dataSource: Datasource;

    private host: ComboBoxComponent|GridComponent;

    constructor(
        @Host() @Self() @Optional() hostCombobox: ComboBoxComponent,
        @Host() @Self() @Optional() hostGrid: GridComponent) {
        this.host = hostGrid || hostCombobox;
    }

    ngAfterViewInit(): void {
        this.dataSource.assign(this.host);
    }

    ngOnDestroy(): void {
        this.dataSource.clean();
    }

}
